import styled from 'styled-components';

export const ContainerWrapper = styled.div`
  position: fixed;
  top: 0;
  width: 100%;
  /* height: 100px; */
`;

export const Container = styled.div`
  width: 100%;
  height: 90%;
  margin: auto;
  background: rgba(255, 255, 255, 1);
  border-bottom-left-radius: 30px;
  border-bottom-right-radius: 30px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`;

export const Label = styled.div`
  font-size: 0.7rem;
  margin-top: 15px;
`;
export const Address = styled.div`
  font-size: 1rem;
  margin: 5px 20px;
  text-align: center;
  color: rgb(230, 158, 33);
`;
export const Hint = styled.div`
  font-size: 0.7rem;
  margin-bottom: 15px;
`;
